import type { Queue } from "@/lib/types";

/** What the Select says for "no default line": the API's null. */
export const NO_LINE = "none";

export interface LeadLineOption {
  value: string;
  label: string;
  description?: string;
  disabled?: boolean;
}

/**
 * The choices for the line a new lead on no campaign is given from (ADR-184 in `platform`):
 * nobody, then every enabled line by name. core-api refuses a disabled line, so one is offered
 * only when it is the line already set, flagged, so the admin sees why leads stopped going to it.
 */
export function leadLineOptions(queues: readonly Queue[], current: number | null): LeadLineOption[] {
  const shown = queues
    .filter((q) => q.enabled || q.id === current)
    .sort((a, b) => a.name.localeCompare(b.name));
  return [
    {
      value: NO_LINE,
      label: "Nobody",
      description: "A lead on no campaign is given to nobody, and Slack asks the channel for someone.",
    },
    ...shown.map((q) => ({
      value: String(q.id),
      label: q.name,
      description: q.enabled ? (q.campaign_name ?? "A line of no campaign") : "Disabled: leads are given to nobody until it is enabled",
      disabled: !q.enabled,
    })),
  ];
}

/** The API's `default_line_id` for a chosen option. */
export function leadLineValue(option: string): number | null {
  return option === NO_LINE ? null : Number(option);
}
